import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-plan-summary',
  templateUrl: './plan-summary.component.html',
  styleUrls: ['./plan-summary.component.scss']
})
export class PlanSummaryComponent {
  @Input() planSummary: any[] = [];
  @Input() coverageLevel: any;
}